import { router } from '~/router';
import EntitiesView from 'Components/EntitiesView';
import { actions } from 'ducks/sites';
import React from 'react';
import { useSelector } from 'react-redux';
import columns from 'utils/columns/sites';

const onRowClick = event => router.navigate(`/sites/${event.currentTarget.dataset.id}`);

const Components = props => {
    const stateProps = useSelector(state => state.sites);

    const { useChangeSearch, useChangeSort, useFetchAll, useToggleAll, useToggleOne } = actions;
    const toggleOne = useToggleOne();
    const actionProps = {
        changeSearch: useChangeSearch(),
        changeSort: useChangeSort(),
        fetchData: useFetchAll(),
        toggleAll: useToggleAll(),
        toggleOne: event => {
            event.stopPropagation();
            return toggleOne(event.target.name);
        }
    };

    return <EntitiesView
        columns={columns}
        onRowClick={onRowClick}
        {...stateProps}
        {...actionProps}
        {...props}
    />;
};

export default Components;
